var _defs, _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "find_svg__a",
    x1: 66.63,
    y1: 61.58,
    x2: 1013.41,
    y2: 1022.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70d48c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "find_svg__b",
    x1: 66.63,
    y1: 61.58,
    x2: 1013.41,
    y2: 1022.55,
    xlinkHref: "#find_svg__a"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 480,
    cy: 481.14,
    rx: 340.27,
    ry: 341.14,
    fill: "url(#find_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1014 966L843.49 795.41A481.73 481.73 0 00666.88 37.84 480.33 480.33 0 000 481.14a479.57 479.57 0 00795.6 362.54L966 1014a34 34 0 0048-48zM640.33 861.84A412.34 412.34 0 0168 481.14a411.6 411.6 0 11572.33 380.7z",
    fill: "url(#find_svg__b)"
  })));
}
export default SvgFind;